import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Cashpurr } from '@/components/ui/cashpurr';
import { CashpurrChat } from '@/components/ui/cashpurr-chat';
import { MessageCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

interface CashpurrFABProps {
  className?: string;
}

export const CashpurrFAB: React.FC<CashpurrFABProps> = ({ className }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);

  React.useEffect(() => {
    const handler = (e: any) => {
      setIsChatOpen(true);
      const detail = e?.detail || {};
      if ((window as any).cashpurrChat?.prefill && detail.prefill) {
        setTimeout(() => (window as any).cashpurrChat.prefill(detail.prefill), 0);
      }
      if ((window as any).cashpurrChat?.setMeta && detail.meta) {
        setTimeout(() => (window as any).cashpurrChat.setMeta(detail.meta), 0);
      }
    };
    window.addEventListener('open-cashpurr', handler as any);
    return () => window.removeEventListener('open-cashpurr', handler as any);
  }, []);

  return (
    <>
      <Button
        onClick={() => setIsChatOpen(true)}
        className={cn(
          'fixed bottom-6 right-6 w-14 h-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 z-50',
          'bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary/70',
          'flex items-center justify-center p-0',
          className
        )}
        size="lg"
      >
        <Cashpurr size="sm" mood="excited" className="text-white" />
        <span className="sr-only">Chat with Cashpurr</span>
      </Button>

      <CashpurrChat 
        isOpen={isChatOpen} 
        onClose={() => setIsChatOpen(false)} 
      />
    </>
  );
};
